import { createAction, props } from '@ngrx/store';
import { User } from 'account-hybrid/core/authentication';


export const signOut = createAction('[Authentication] Sign Out');

export const signIn = createAction('[Authentication] Sign In', props<{ session: User }>());
